import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pincodeNumberFormat',
  standalone: true,
})
export class PincodeNumberFormatPipe implements PipeTransform {
  transform(value: unknown, ...args: unknown[]): string {
    if (!value) {
      return '';
    }
    const pincodeStr = value.toString();
    if (pincodeStr.length !== 6) {
      return pincodeStr; // Return as is if not exactly 6 digits
    }
    return `${pincodeStr.slice(0, 3)} ${pincodeStr.slice(3)}`;
  }
}
